import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import Close from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import HeaderLinks from "./HeaderLinks.jsx";
// import { Socials } from './SocialTop';
// import Slide from 'react-reveal/Slide';
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import { Link as LINKS } from "react-router-dom";
import Button from "components/CustomButtons/Button.jsx";
import { connect } from "react-redux";

class TopMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  async toggleDrawer() {
    await this.setState({ open: false });
  }
  async openDrawer() {
    await this.setState({ open: true });
  }

  render() {
    const { open } = this.state;
    const { token } = this.props;
    return (
      <AppBar position="sticky" className="AppBartop">
        <Toolbar className="ToolBartop">
          {/* <Slide bottom> */}
          <IconButton
            className="menumobile"
            aria-label="منو"
            onClick={this.openDrawer.bind(this)}
          >
            <MenuIcon />
          </IconButton>

          {/* </Slide> */}
          <Drawer
            anchor="right"
            open={open}
            onClose={this.toggleDrawer.bind(this)}
            className="mobileDrawer"
          >
            <div className="mobilemenu">
              <IconButton
                className="menumobile"
                aria-label="بستن"
                onClick={this.toggleDrawer.bind(this)}
                style={{
                  margin: "0 auto 20px",
                  border: "1px solid white",
                  padding: "0",
                  borderRadius: "4px"
                }}
              >
                <Close />
              </IconButton>
              <HeaderLinks close={() => this.setState({ open: false })} />
              {/* <div className='mobilesocial' >
                                <Socials />
                            </div> */}
            </div>
          </Drawer>
          {/* <Slide bottom> */}
          {token && (
            <div className="mobilebut">
              <List>
                <ListItem>
                  <Button color="transparent" target="_blank">
                    <LINKS to="/posts">اطلاع رسانی قیمت</LINKS>
                  </Button>
                </ListItem>
                <ListItem>
                  <Button color="transparent" target="_blank">
                    <LINKS to="/market">اطلاعات بازار</LINKS>
                  </Button>
                </ListItem>
              </List>
            </div>
          )}
          <div className="headerlinktop">
            <HeaderLinks />
          </div>
          {/* </Slide> */}
          {/* <div className='topmenusocial'>
                        <Slide bottom>
                            <Socials />
                        </Slide>
                    </div> */}
        </Toolbar>
      </AppBar>
    );
  }
}

function mapStateToProps(state) {
  return { token: state.token };
}
export default connect(mapStateToProps, null)(TopMenu);
